import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { BasebenutzerService } from './api/basebenutzer.service';
import { BaseconfigService } from './api/baseconfig.service';
import { BaseerweiterungService } from './api/baseerweiterung.service';
import { BaseformatService } from './api/baseformat.service';
import { BaseimageService } from './api/baseimage.service';
import { BaselinkService } from './api/baselink.service';
import { BaselogService } from './api/baselog.service';
import { BaseorderService } from './api/baseorder.service';
import { BaseparameterService } from './api/baseparameter.service';
import { BasepermissionService } from './api/basepermission.service';
import { BaserubrikenService } from './api/baserubriken.service';
import { BasesettingService } from './api/basesetting.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
